/**
 * NotAuthorizedPage Component
 */

import { pushPostAuthenticationRequestPage } from '../../../../redux/actions/postAuthenticationRequests';
import { toggleLogInFormVisibility } from '../../../../redux/actions/ui';
import { createHref } from '../../../../utils/router';
import './styles.scss';

import { WithRouter, withRouter } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import Page from '../../../../containers/Page';
import Button from '../../../atoms/buttons/Button';
import Heading from '../../../atoms/text/Heading';

interface IOwnDispatchProps {
  showLogInForm(): void;
}

interface IOwnProps  {
  message?: string;
}

type NotAuthorizedPageProps = IOwnProps & IOwnDispatchProps & WithRouter;

const classes = new BEM('not-authorized');

const NotAuthorizedPage: React.SFC<NotAuthorizedPageProps> = ({ message, showLogInForm }) => (
  <Page id="not-authorized" noIndex>
    <Heading is="h2" textColor="bw6" {...classes('error-message')}>
      {message}
    </Heading>
    <Button
      onClick={showLogInForm}
      label="Log In"
      size="large"
      colorScheme="white"
      variant="pill"
      withShadow
    />
  </Page>
);

const ConnectedNotAuthorizedPage = connect<{}, IOwnDispatchProps, IOwnProps & WithRouter, IStoreState>(
  null,
  (dispatch, ownProps) => ({
    showLogInForm: () => {
      dispatch(pushPostAuthenticationRequestPage({ page: createHref(ownProps.match.location) }));
      dispatch(toggleLogInFormVisibility(true));
    },
  }),
)(NotAuthorizedPage);

export default withRouter<IOwnProps>(ConnectedNotAuthorizedPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/NotAuthorized/index.tsx